module.exports = __webpack_public_path__ + "static/media/Isha_Khutafale.5c48c3cf.jpg";